import Button from "@scripts/react/components/Button";

interface AddFilesButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

export function AddFilesButton({ onClick, disabled = false }: AddFilesButtonProps) {
    return (
        <Button
            type="secondary"
            size="xlarge"
            shape="square"
            onClick={onClick}
            disabled={disabled}
            aria-label="Add files"
            title="Add files"
            className="addFilesButton group"
        >
            <i className="far fa-plus transition-transform duration-200 group-hover:scale-125" />
        </Button>
    );
}
